import { LongErrorStackPromise } from './LongErrorStackPromise';

/**
 * This promise will maintain stack traces in errors that new Promise() won't
 */
const doLongStackTraces = !!process.env['LONG_STACK_TRACES'];

// type Executor1 = (resolve: () => void, reject: (reason?: any) => void) => void;
type Executor<T> = (
	resolve: (value: T | PromiseLike<T>) => void,
	reject: (reason?: any) => void
) => void;
// type Executor<T> = Executor2<T> | Executor1;

export function makePromise<T>(executor: Executor<T>): Promise<T> {
	if (doLongStackTraces) {
		return new LongErrorStackPromise(executor);
	} else {
		return new Promise(executor);
	}
}
